'use strict';

// The welcome offer is validated by the native Shopify WELCOME10 discount.
const TJS_ANNOUNCEMENTS = Object.freeze([
  {text:'Sign up for 10% off your first order.', label:'Details', action:'offer'},
  {text:'Made for your story. Discover custom design.', label:'Explore', href:'#/custom'},
  {text:'Here for every detail. Shipping & returns information.', label:'Learn more', href:'#/policy/shipping'}
]);

// Official contact details only. Leave unknown values empty; the header then
// opens a helpful availability notice instead of a guessed number or address.
const TJS_CONTACT = Object.freeze({
  phone:'(646) 554-3729', email:'support@thejewelrystudio.us', whatsapp:'', hours:'Monday to Friday, 10 a.m. to 6 p.m., New York time, excluding U.S. federal holidays',
  virtualAppointmentUrl:'', inPersonAppointmentUrl:'', address:'', mapUrl:''
});

// A single agency-editable location for official social accounts.
// Paste the complete HTTPS profile URL between the quotes when an account exists.
// Public handles supplied by the owner; never put login details in this file.
// Empty values stay hidden until the owner supplies the exact public page URL.
const TJS_SOCIAL_PROFILES = {
  Instagram: 'https://www.instagram.com/thejewelrystudio.us/',
  Facebook: 'https://www.facebook.com/people/The-Jewelry-Studio/61594705391688/',
  TikTok: 'https://www.tiktok.com/@tjs_usa',
  YouTube: 'https://www.youtube.com/@Thejewelrystudio',
  LinkedIn: 'https://www.linkedin.com/in/the-jewelry-studio-usa-inc-b16a5b435/',
  Reddit: 'https://www.reddit.com/user/TJS_us/',
  X: 'https://x.com/tjs_us',
  Pinterest: 'https://www.pinterest.com/TJS_USA/',
  Snapchat: 'https://www.snapchat.com/add/TJS_USA',
  Etsy: 'https://www.etsy.com/in-en/people/yfjvnmg3a1m8yumb'
};

function tjsSocialProfileUrl(name,value){
  const allowed={Instagram:['instagram.com'],Facebook:['facebook.com'],TikTok:['tiktok.com'],YouTube:['youtube.com'],LinkedIn:['linkedin.com'],Reddit:['reddit.com'],X:['x.com','twitter.com'],Pinterest:['pinterest.com','in.pinterest.com'],Snapchat:['snapchat.com'],Etsy:['etsy.com']};
  try {
    const candidate=new URL(value);
    if(candidate.protocol!=='https:'||candidate.username||candidate.password||candidate.port||!allowed[name]?.includes(candidate.hostname.replace(/^www\./,'')))return '';
    if(candidate.pathname==='/'||/^\/(?:login|signin|signup|accounts|oauth|auth)(?:\/|$)/i.test(candidate.pathname))return '';
    // Keep only Facebook's public numeric page ID; strip tracking and fragments.
    const pageId=name==='Facebook'&&candidate.pathname==='/profile.php'?candidate.searchParams.get('id'):'';
    candidate.search='';candidate.hash='';
    if(pageId&&/^\d+$/.test(pageId))candidate.searchParams.set('id',pageId);
    else if(candidate.pathname==='/profile.php')return '';
    return candidate.href;
  }catch{return '';}
}

(() => {
  const container=document.getElementById('footer-socials');
  if(!container)return;
  const marks={
    Instagram:'<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8" fill="currentColor" stroke="none"/>',
    Facebook:'<path d="M14.5 21v-8h2.8l.5-3h-3.3V8.2c0-.9.4-1.5 1.6-1.5H18V3.9c-.6-.1-1.7-.2-2.8-.2-2.8 0-4.6 1.7-4.6 4.7V10H8v3h2.6v8Z" fill="currentColor" stroke="none"/>',
    TikTok:'<path d="M14 3v12.4a4.6 4.6 0 1 1-4-4.6v3.1a1.6 1.6 0 1 0 1 1.5V3Zm0 0c.5 3.1 2 4.6 5 5v3c-2-.1-3.7-.8-5-2"/>',
    YouTube:'<rect x="2" y="5" width="20" height="14" rx="4"/><path d="m10 9 6 3-6 3Z" fill="currentColor" stroke="none"/>',
    LinkedIn:'<rect x="3" y="3" width="18" height="18" rx="1"/><path d="M7.5 10v7M11.5 17v-7m0 3c0-4 5-4 5 0v4"/><circle cx="7.5" cy="7" r=".9" fill="currentColor" stroke="none"/>',
    Reddit:'<ellipse cx="12" cy="14" rx="8" ry="5.5"/><path d="m12 8.5 1.7-6 4.1 1M4.5 11a2.3 2.3 0 1 0-1 3m16-3a2.3 2.3 0 1 1 1 3M8 16c2 1.5 6 1.5 8 0"/><circle cx="19" cy="3.8" r="1.5"/><circle cx="8.7" cy="13" r="1" fill="currentColor" stroke="none"/><circle cx="15.3" cy="13" r="1" fill="currentColor" stroke="none"/>',
    X:'<path d="m4 3 12.6 18H20L7.4 3ZM20 3 4 21"/>',
    Pinterest:'<circle cx="12" cy="12" r="9"/><path d="m9 20 2.4-10m-1 4c4 3 7-1 7-4a5.4 5.4 0 0 0-10.8 0c0 1.5.5 2.5 1.4 3"/>',
    Snapchat:'<path d="M7 10V8a5 5 0 0 1 10 0v2l2-1 1 2-3 2c0 2 2 3 4 4l-3 1-.5 2-2.5-.5L12 21l-3-1.5-2.5.5-.5-2-3-1c2-1 4-2 4-4l-3-2 1-2Z"/>',
    Etsy:'<path d="M18 4H6v16h12M6 12h9M18 4v3M15 10v4M18 17v3"/>'
  };
  let linked=0;
  container.replaceChildren();
  for(const [name,value] of Object.entries(TJS_SOCIAL_PROFILES)) {
    const url=tjsSocialProfileUrl(name,value);
    if(!url||!marks[name])continue;
    const element=document.createElement('a');
    element.innerHTML=`<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${marks[name]}</svg>`;
    element.href=url;element.target='_blank';element.rel='noopener noreferrer';element.title=name;element.setAttribute('aria-label',`The Jewelry Studio on ${name} (opens in a new tab)`);
    container.append(element);
    linked++;
  }
  const status=document.getElementById('social-status');
  if(status)status.textContent=linked?'Follow the studio, wherever you feel at home.':'Our social profiles are coming soon.';
})();
